import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleLocatiiComponent } from './module-locatii.component';
import { AddModuleLocatiiComponent } from './add-module-locatii/add-module-locatii.component';
import { EditModuleLocatiiComponent } from './edit-module-locatii/edit-module-locatii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        ModuleLocatiiComponent,
        AddModuleLocatiiComponent,
        EditModuleLocatiiComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ModuleLocatiiComponent]
})
export class ModuleLocatiiModule { }
